// Add your custom JS here.








// function addCategoryTitleToProducts() {
//     var titleText = document.querySelector('.page-title').innerText;
//     document.querySelector('.centered').innerText = titleText;
// }

// $(document).ready(function() {
//     if ($('.page-title').length && $('.site-main ul.products').length) {
//         addCategoryTitleToProducts();
//     }
// });


// $(document).ready(function() {
//     var totalWidth = 0;
//     $('ul.variable-items-wrapper li').each(function() {
//         totalWidth += $(this).outerWidth(true);
//     });
//     $('ul.variable-items-wrapper').css('width', totalWidth + 'px');
//     totalWidth += 5;
//     $('.variations_form').css('width', totalWidth + 'px');

// });

$(document).ready(function() {
    $(".open-menu-button").click(function() {
      $(this).toggleClass("open"); // Переключаем класс "open"
      $(".category-menu").slideToggle(); // Переключаем видимость .category-menu
    });
  });
  

  $(document).ready(function() {
    const links = $('.woocommerce-loop-product__link');

    function toggleImageVisibility(link) {
        const images = link.find('.product-image');
        let currentImageIndex = 0;
        let intervalId = null;

        function showNextImage() {
            images.hide();
            images.eq(currentImageIndex).show();
            currentImageIndex = (currentImageIndex + 1) % images.length;
        }

        // Для десктопных устройств
        link.hover(function() {
            showNextImage();
            intervalId = setInterval(showNextImage, 1000);
        }, function() {
            clearInterval(intervalId);
        });

        // Для мобильных устройств
        link.on('touchstart', function() {
            showNextImage();
            intervalId = setInterval(showNextImage, 1000);
        });

        link.on('touchend', function() {
            clearInterval(intervalId);
        });
    }

    links.each(function() {
        toggleImageVisibility($(this));
    });
});

  
$(document).ready(function() {
    // Проверяем, есть ли на body класс 'product-template-default'
    if ($('body').hasClass('product-template-default')) {
        // Получаем элемент с классом '.summary p.price'
        var priceElement = $('.summary p.price');

        // Убедимся, что элемент существует
        if (priceElement.length) {
            // Удаляем элемент из текущего местоположения
            var priceHtml = priceElement.detach();

            // Вставляем элемент после '.summary .product_title'
            $('.summary .product_title').after(priceHtml);
        }
    }
});




// const spaceHolder = document.querySelector('.space-holder');
// const horizontal = document.querySelector('.horizontal');
// spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`;

// function calcDynamicHeight(ref) {
//   const vw = window.innerWidth;
//   const vh = window.innerHeight;
//   const objectWidth = ref.scrollWidth;
//   return objectWidth - vw + vh + (vw/3); // 150 is the padding (in pixels) desired on the right side of the .cards container. This can be set to whatever your styles dictate
// }

// window.addEventListener('scroll', () => {
//   const sticky = document.querySelector('.sticky');
//   horizontal.style.transform = `translateX(-${sticky.offsetTop}px)`;
// });

// window.addEventListener('resize', () => {
//   spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`;
// });


// var pages = document.querySelectorAll('.products, .product-images');

// pages.forEach(function(page) {
//   window.onscroll = function () {
//     // Horizontal Scroll.
//     var y = document.body.getBoundingClientRect().top;
//     page.scrollLeft = -y;
//   }

//   // Adjust the body height if the window resizes.
//   window.onresize = function() {
//     var w = page.scrollWidth-window.innerWidth+window.innerHeight;
//     document.body.style.height = w + 'px';
//   }
//   // Initial resize.
//   window.onresize();
// });


const slider = document.querySelector('.slider');
const slides = document.querySelectorAll('.slider li');
const progressBars = document.querySelectorAll('.progress-bar div');
const totalSlides = slides.length;
let currentIndex = 0;
let slideInterval;

// Функция обновления слайда и прогресс-бара
function goToSlide(index) {
  currentIndex = (index + totalSlides) % totalSlides;
  slider.style.transform = `translateX(-${currentIndex * 100}%)`;
  
  // Обновление анимации прогресс-бара
  progressBars.forEach((bar, idx) => {
    bar.style.animation = idx === currentIndex ? 'progress 3s linear infinite' : 'none';
  });
}

// Автоматическая смена слайдов
function startSlideShow() {
  slideInterval = setInterval(() => {
    goToSlide(currentIndex + 1);
  }, 3000);
}

// Остановка автопереключения при взаимодействии пользователя
function stopSlideShow() {
  clearInterval(slideInterval);
}

// Обработчики для кнопок навигации
document.querySelector('.arrow-left').addEventListener('click', () => {
  stopSlideShow();
  goToSlide(currentIndex - 1);
  startSlideShow();
});

document.querySelector('.arrow-right').addEventListener('click', () => {
  stopSlideShow();
  goToSlide(currentIndex + 1);
  startSlideShow();
});

// Запуск автопереключения слайдов
startSlideShow();

    